import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { siteMetadata } from '../../gatsby-config'
import './bootstrap.min.css';
import 'typeface-lato';

import TopBar from '../components/TopBar'
// import SiteNavi from '../components/SiteNavi'
import SiteNaviSticky from '../components/SiteNaviSticky'
import Footer from '../components/Footer';
import './index.scss'

class Template extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			scrolledPast: false,
		}

    this.handleScroll = this.handleScroll.bind(this);
	}

	handleScroll(event) {
    if (window.pageYOffset > 95 && this.state.scrolledPast === false) {
			this.setState({ scrolledPast: true });
		}
		if (window.pageYOffset < 95 && this.state.scrolledPast === true) {
			this.setState({ scrolledPast: false });
		}
	}

  componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
  }

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

  render() {
		const { location, children } = this.props;
		const { scrolledPast, scrollPos } = this.state;
    return (
      <div className="main-wrap">
				<SiteNaviSticky title={siteMetadata.title} {...this.props} />
				{children()}
				<Footer />
      </div>
    )
  }
}

export default Template




// WEBPACK FOOTER //
// ./src/layouts/index.js